import { Link } from 'react-router-dom'
import styles from './SurveyDetailsHeader.module.scss'

export const SurveyDetailsHeader = () => (
  <div className={styles.root}>
    <Link className={styles.backLink} to="/surveys">
      {'Вернуться к списку опросов'}
    </Link>
  </div>
)
